export default (editor, buttons) =>
  buttons.map((button) => {
    return editor.ui.registry.addButton(
      button.identifier,
      button.config(editor),
    )
  })
